/* eslint-disable @typescript-eslint/no-explicit-any */
import { debounce } from 'lodash';
import React from 'react';

import useLayoutEffect from '@swf/core/hooks/useIsomorphicLayoutEffect';

export default (callback: (...args: any) => void, delay: number) => {
  const callbackRef = React.useRef(callback);

  useLayoutEffect(() => {
    callbackRef.current = callback;
  });

  return React.useMemo(() => debounce((...args) => callbackRef.current(...args), delay), [delay]);
};
